<template>
  <section class="content">
    <div class="information-content">
      <div class="form-group" v-show="isAdmin">
        <label>APP ID</label>
        <input
          type="text"
          class="form-control"
          placeholder="Text"
          v-model="formData.appid"
          disabled
        >
      </div>
      <div class="form-group">
        <label>Name</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="name"
          class="form-control"
          placeholder="name"
          v-model="formData.name"
        >
      </div>
      <div class="form-group">
        <label>Description</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="description"
          class="form-control"
          placeholder="description"
          v-model="formData.description"
        >
      </div>
      <div class="form-group">
        <label>Version</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="version"
          class="form-control"
          placeholder="version"
          v-model="formData.version"
        >
      </div>
      <div class="form-group">
        <label>No8version</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="no8version"
          class="form-control"
          placeholder="no8version"
          v-model="formData.no8version"
        >
      </div>
      <div class="form-group">
        <label>Uppermd5</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="uppermd5"
          class="form-control"
          placeholder="uppermd5"
          v-model="formData.uppermd5"
        >
      </div>
      <div class="form-group">
        <label>Upperurl</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="upperurl"
          class="form-control"
          placeholder="upperurl"
          v-model="formData.upperurl"
        >
      </div>
      <div class="form-group">
        <label>Lowermd5</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="lowermd5"
          class="form-control"
          placeholder="lowermd5"
          v-model="formData.lowermd5"
        >
      </div>
      <div class="form-group">
        <label>Lowerurl</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="lowerurl"
          class="form-control"
          placeholder="lowerurl"
          v-model="formData.lowerurl"
        >
      </div>
      <div class="form-group">
        <label>Lowermd5nostm8</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="lowermd5nostm8"
          class="form-control"
          placeholder="lowermd5nostm8"
          v-model="formData.lowermd5nostm8"
        >
      </div>
      <div class="form-group">
        <label>Lowerurlnostm8</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="lowerurlnostm8"
          class="form-control"
          placeholder="lowerurlnostm8"
          v-model="formData.lowerurlnostm8"
        >
      </div>
      <div class="form-group">
        <label>Logic</label>
        <input
          type="text"
          :disabled="!isSuperAdmin"
          name="logic"
          class="form-control"
          placeholder="logic"
          v-model="formData.logic"
        >
      </div>
    </div>
  </section>
</template>
<script>
import api from "../../api";
import config from "../../config";
import utils from "../../utils";

export default {
  name: "device-type-form",
  props: {
    withInitialData: Boolean
  },
  data() {
    return {
      formData: {
        appid: null,
        name: null,
        description: null,
        version: null,
        no8version: null,
        uppermd5: null,
        upperurl: null,
        lowermd5: null,
        lowerurl: null,
        lowermd5nostm8: null,
        lowerurlnostm8: null,
        logic: null
      },
      isSuperAdmin: utils.checkIsSuperAdmin(),
      isAdmin: utils.checkIsAdmin()
    };
  },
  methods: {
    async fetch() {
      const { appid } = this.$route.query;
      const res = await api.post({
        path: "/devicetypes/get?_type=json",
        data: { appid },
        withLoading: true
      });
      this.formData = res;
    },
    async update() {
      const data = this.formData;
      console.log("data", data);

      const res = await api.post({
        path: `/devicetypes/update?_type=json`,
        data,
        withLoading: true
      });
      console.log("res", res);

      this.requestClearCache();
    },
    async requestClearCache() {
      const hosts = [];
      if (process.env.NODE_ENV === "production") {
        hosts.push("https://api-as01.dinsafer.com");
        hosts.push("https://api-as02.dinsafer.com");
        hosts.push("https://api-eu01.dinsafer.com");
        hosts.push("https://api-us01.dinsafer.com");
      } else {
        hosts.push(config.blackholeServerURI)
      }
      hosts.map(host => this.requestClearCacheByHost(host));
    },
    async requestClearCacheByHost(host) {
      const { appid } = this.$route.query;
      let res = await api.post_blackhole({
        path: "/device/sendcmdadmin",
        cmd: "CLEAN_DEVICE_VERSION_CACHE",
        appid,
        host,
        noError: true,
        // withLoading: true,
      });
      console.log(host, "clear cache result", res);
    },
  },
  mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// DeviceTypesForm.vue?7d412a01